import { createFileRoute } from '@tanstack/react-router';
import CreatePage from '../views/create';

export const Route = createFileRoute('/create/')({
  component: CreatePage,
});
